module.exports = __webpack_public_path__ + "img/Nyromantikk_Tanker-i-tida_Scott.c548d702.jpg";